<script setup lang="ts">
import { useSessionStore } from '../../stores';
import { Session } from '../../types/session';

import Vocab from './Vocab/Vocab.vue';
import Lecture from './Lecture/Lecture.vue';
import WorkBook from './Workbook/WorkBook.vue';
import Practice from './Practice/Practice.vue';
import Quiz from './Quiz/Quiz.vue';
import Custom from './Custom/Custom.vue';
import Summary from './Summary/Summary.vue';

const sessionStore = useSessionStore()

const tabs = {
    [Session.vocab]: Vocab,
    [Session.lecture]: Lecture,
    [Session.workbook]: WorkBook,
    [Session.practice]: Practice,
    [Session.practice2]: Practice,
    [Session.quiz]: Quiz,
    [Session.summary]: Summary,
    [Session.custom]: Custom
}
</script>

<template>
    <div class="flex flex-1 w-full overflow-hidden">
        <div class="max-w-full bg-white rounded-lg flex-1 border-2 border-gray-200">
            <component :is="tabs[sessionStore.currentSession]"></component>
        </div>
    </div>
</template>